export default __webpack_public_path__ + "static/media/fc-40-3f3e3c.27057b66.svg";